'use client';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '@/components/ErrorFallback';
import { telemetry } from '@lingugeek/telemetry-client';

export default function ErrorBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onError={(error, errorInfo) => {
        console.error('Error caught by ErrorBoundary:', error, errorInfo);

        telemetry.logError(error, undefined, {
          componentStack: errorInfo.componentStack,
          errorBoundary: true,
        });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
